import { render, staticRenderFns } from "./CompanySupplierRequestShowOne.vue?vue&type=template&id=b0d2353a&scoped=true&"
import script from "./CompanySupplierRequestShowOne.vue?vue&type=script&lang=js&"
export * from "./CompanySupplierRequestShowOne.vue?vue&type=script&lang=js&"
import style0 from "./CompanySupplierRequestShowOne.vue?vue&type=style&index=0&id=b0d2353a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0d2353a",
  null
  
)

export default component.exports